import { createEvent, createStore, restore, sample } from 'effector'
import { fx } from 'src/libs'
import { buildQuery, ListRequest } from 'src/pages/goldenMay2026/utils'
import {
  DisableTaskTypeRequest,
  ModerationTaskRequest,
  Task,
  TasksResponse,
  TasksTypesResponse,
  TaskType,
} from './types'
import {
  NotificationPayload,
  showNotification,
} from 'src/pages/goldenMay2026/model'

export const onChangeTaskList = createEvent<Partial<ListRequest>>()
export const taskTypeListLoad = createEvent<void | any>()
export const disableTaskTypeEvent = createEvent<DisableTaskTypeRequest>()

export const getTasksFx = fx<ListRequest, TasksResponse>({
  method: 'GET',
  url: `/promo/golden_may_2026/participant_task`,
})

export const getTaskTypesFx = fx<void | any, TasksTypesResponse>({
  method: 'GET',
  url: `/promo/golden_may_2026/task`,
})

export const disableTaskTypeFx = fx<DisableTaskTypeRequest, void>({
  method: 'PUT',
  url: `/promo/golden_may_2026/task/`,
})

export const moderationTaskFx = fx<ModerationTaskRequest, void>({
  method: 'PUT',
  url: `/promo/golden_may_2026/participant_task/`,
})

export const $tasks = createStore<Task[]>([]).on(
  getTasksFx.doneData,
  (_, res) => res.body.items,
)

export const $totalCountOfTasks = restore(
  getTasksFx.doneData.map((a) => a.body.total),
  0,
)

export const $tasksTypes = createStore<TaskType[]>([]).on(
  getTaskTypesFx.doneData,
  (_, res) => res.body.items,
)

export const $tasksParams = createStore<ListRequest>({
  page: 1,
  limit: 10,
  orderBy: '',
  orderDirection: '',
  searchText: {},
  filters: { status: ['check'] },
}).on(onChangeTaskList, (state, payload) => ({ ...state, ...payload }))

sample({
  clock: $tasksParams,
  fn: buildQuery,
  target: getTasksFx,
})

sample({
  clock: [taskTypeListLoad, disableTaskTypeFx.done],
  target: getTaskTypesFx,
})

sample({
  clock: disableTaskTypeEvent,
  fn: ({ id }) => ({ url: `/promo/golden_may_2026/task/${id}` }),
  target: disableTaskTypeFx,
})

sample({
  clock: moderationTaskFx.done,
  source: $tasksParams,
  fn: buildQuery,
  target: getTasksFx,
})

sample({
  clock: [
    getTasksFx.failData,
    getTaskTypesFx.failData,
    disableTaskTypeFx.failData,
    moderationTaskFx.failData,
  ],
  fn: (error): NotificationPayload => ({
    type: 'error',
    message: 'Request failed',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})

sample({
  clock: disableTaskTypeFx.doneData,
  fn: (): NotificationPayload => ({
    type: 'success',
    message: 'Success',
    description: 'Task disabled',
  }),
  target: showNotification,
})

sample({
  clock: moderationTaskFx.doneData,
  fn: (): NotificationPayload => ({
    type: 'success',
    message: 'Success',
    description: 'Participant task status updated',
  }),
  target: showNotification,
})
